// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/admin/admin.scss
// module id = 1090
// module chunks = 3